module.exports = __webpack_public_path__ + "img/water-level-5_0.771d7480.png";